import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";

export const ActionButton = styled(Button)(({ theme }) => ({
  minWidth: "40px",
  width: "40px",
  height: "40px",
  padding: "8px",
  borderRadius: "8px",
  backgroundColor: theme.palette.jigsaw.lightBlue || "#BBD600",
  color: "white",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "&:hover": {
    backgroundColor: theme.palette.jigsaw.darkBlue || "#A0C500",
  },
  "&:disabled": {
    backgroundColor: "#ccc",
    color: "#888",
  },
  "& .MuiSvgIcon-root": {
    fontSize: "20px",
  },
}));

